import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IUsuarioReestablecerPasswordModel } from 'src/app/models/interfaces/seguridad/IUsuarioReestablecerPasswordModel';
import { UsuarioReestablecerPasswordModel } from 'src/app/models/seguridad/UsuarioReestablecerPasswordModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { SeguridadUsuarioService } from 'src/app/services/seguridad/seguridad-usuario.service';

@Component({
  selector: 'app-restablecer-contrasena',
  templateUrl: './restablecer-contrasena.component.html',
  styleUrls: ['./restablecer-contrasena.component.css']
})
export class RestablecerContrasenaComponent implements OnInit {
  hideNuevaContrasena = true;
  hideConfirmarContrasena = true;

  model: IUsuarioReestablecerPasswordModel = new UsuarioReestablecerPasswordModel();
  constructor(
    private route: ActivatedRoute,
    private seguridadUsuarioService: SeguridadUsuarioService,
    private alertDialogService: AlertDialogService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.model.id = params['id'];
      
    });

    this.route.queryParams.subscribe((params) => {
      this.model.token = params.token;
    });
  }

  submit(): void {
    console.log(this.model);
    this.seguridadUsuarioService.reestablecerPassword(this.model).subscribe((data) => {
      this.alertDialogService.open('Se ha RESTABLECIDO TU CONTRASEÑA.'); //options
        this.router.navigate(['/']);
    });
  }

  cancelar(): void {
    this.router.navigate(['/']);
  }
}
